import { ref, update } from "firebase/database";
import { type ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";
import { getFirebase } from "../firebase/init.js";
import type { EditableScene } from "../lib/scene-edits.js";
import SceneAspectsEditor from "./SceneAspectsEditor.js";
import SceneCountdownsEditor from "./SceneCountdownsEditor.js";
import SceneZonesEditor from "./SceneZonesEditor.js";

interface Props {
  scenePath: string;
  scene: EditableScene;
}

export default function SceneEditor({ scenePath, scene }: Props): ReactElement {
  const { t } = useTranslation();
  const [name, setName] = useState(scene.name);

  async function saveName(): Promise<void> {
    if (name.trim() === scene.name || name.trim().length === 0) return;
    const { db } = getFirebase();
    await update(ref(db), { [`${scenePath}/name`]: name.trim() });
  }

  return (
    <article className="space-y-6">
      <label className="block text-sm">
        <span>{t("edit.scene.name")}</span>
        <input
          className="mt-1 w-full rounded border px-2 py-1"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onBlur={saveName}
        />
      </label>
      <SceneAspectsEditor scenePath={scenePath} scene={scene} />
      <SceneZonesEditor scenePath={scenePath} scene={scene} />
      <SceneCountdownsEditor scenePath={scenePath} scene={scene} />
    </article>
  );
}
